<template>
  <div>
    <div class="public">
      <header class="head">
        <div class="head-content">
          <div class="left">查政策</div>
          <login-nav></login-nav>
        </div>
      </header>
      <div class="logo">
        <div class="logo-left">
          <img
            src="../../static/qi_logo.png"
            alt=""
            @click="$router.push('/')"
            style="cursor: pointer"
          />
        </div>
        <div class="logo-right">
          <el-menu
            :default-active="activeIndex"
            active-text-color="#409EFF"
            text-color="#000"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="0">
              <router-link to="/">首页</router-link>
            </el-menu-item>
            <el-menu-item index="1">
              <router-link to="#">政策超市</router-link>
            </el-menu-item>
            <el-submenu index="2">
              <template slot="title">政策匹配</template>
              <el-menu-item index="2-1">
                <router-link to="/accuratePage/matchPage?status=0">模糊匹配 </router-link>
              </el-menu-item>
              <el-menu-item index="2-2">
                <router-link
                  to="/accuratePage/matchPage?status=1"
                  style="display: flex; align-items: center"
                  >精准匹配
                  <img
                    src="../../static/vip_dark.png"
                    style="width: 20px; height: 20px; margin-left: 5px"
                  />
                </router-link>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="icon"></div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/policy">政策超市</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import loginNav from "@/components/loginNav.vue";
export default {
  components: { loginNav },
  data() {
    return {
      activeIndex: "1",
    };
  },
  methods: {
    handleSelect() {
      console.log(111);
    },
  },
};
</script>

<style lang="less" scoped>
a {
  color: #000;
  text-decoration: none;
}
.public {
  .head {
    height: 50px;
    background: #1395f3;
    line-height: 50px;

    &-content {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;
    }
  }

  .logo {
    width: 1200px;
    height: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-left {
      // width: 140px;
      // height: 60px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-image: url("../../static/logo.png");
    }

    &-right {
      // width: 540px;
      height: 60px;
      line-height: 60px;

      .el-menu-demo {
        border: none;
        color: #000 !important;
        ::v-deep .el-submenu__title {
          font-size: 16px;
        }
      }
      a {
        text-decoration: none;
        font-size: 16px;
        display: inline-block;
      }
    }
  }
}
.container {
  width: 1200px;
  height: 31px;
  margin: 20px auto;
  display: flex;
  justify-content: flex-start;
  align-content: flex-end;
  ::v-deep .el-breadcrumb {
    line-height: 25px;
  }
  .icon {
    width: 18px;
    height: 18px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("../../static/hourse.png");
    vertical-align: middle;
    margin-right: 5px;
  }
}
</style>
